import React from "react";
import { FaHeartPulse, FaGraduationCap, FaCartShopping, FaPlane, FaHouse, FaRocket, FaBriefcase, FaTruck } from "react-icons/fa6";
import { Container, SectionHeading, GradientButton, IconTile, ArrowCircle } from "./ui";

const industries = [
  { icon: FaHeartPulse, tone: "blue", label: "Healthcare & Wellness" },
  { icon: FaGraduationCap, tone: "violet", label: "Education & E-learning" },
  { icon: FaCartShopping, tone: "green", label: "Retail & E-commerce" },
  { icon: FaPlane, tone: "orange", label: "Travel & Hospitality" },
  { icon: FaHouse, tone: "red", label: "Real Estate & Property" },
  { icon: FaRocket, tone: "blue", label: "Startups & SaaS" },
  { icon: FaBriefcase, tone: "violet", label: "Professional Services" },
  { icon: FaTruck, tone: "green", label: "Logistics & Transportation" },
];

const Industries = () => (
  <section className="bg-white py-[36px] lg:py-[46px]">
    <Container>
      <SectionHeading
        badge="Industries we serve"
        title="Technology for Every"
        highlight="Ambitious Business."
        subtitle="We develop digital solutions for businesses across industries, adapting our approach to their specific users and challenges."
      />
      <div className="m-swipe mt-[48px] grid gap-[16px] sm:grid-cols-2 lg:grid-cols-4">
        {industries.map((it) => (
          <a
            key={it.label}
            href="/contact-us"
            className="group flex items-end justify-between gap-[12px] rounded-2xl bg-white p-[20px] shadow-card ring-1 ring-slate-100 transition hover:-translate-y-1"
          >
            <div>
              <IconTile icon={it.icon} tone={it.tone} size="lg" />
              <p className="mt-[16px] text-[16px] font-semibold text-ink">{it.label}</p>
            </div>
            <ArrowCircle tone={it.tone} />
          </a>
        ))}
      </div>
      <div className="mt-[40px] text-center">
        <GradientButton href="/contact-us">Find Your Solution</GradientButton>
      </div>
    </Container>
  </section>
);

export default Industries;
